// Network Configuration - Polygon Mainnet
export const POLYGON_CHAIN_ID_MAINNET = 137; // Mainnet (decimal)
export const ACTIVE_CHAIN_ID = POLYGON_CHAIN_ID_MAINNET;

// Contract Addresses - Mainnet
export const DOLPHIN_CONTRACT_ADDRESS = '0x5fcED00Dceb99508600C7b2469D03D9db468Cfac';
export const CONTRACTS = {
  DOLPHIN: "0x5fcED00Dceb99508600C7b2469D03D9db468Cfac", // DolphinExtended contract (updated)
  DOLPCOIN: "0x6B353B019A10e58d02b3a0625560bE5F174026ba",
  USDT: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F", // Official USDT (Tether) contract address on Polygon (6 decimals)
  DOLPHIN_REFERRAL: "0x41AACD75084B37FAACc27defE4Bf86DC6137387A", // DolphinReferral contract (updated)
  DOLPHIN_PAYMENTS: "0xE7a98e970865AFDe72833A9Ca0fAC90116C28277", // DolphinPayments contract (updated)
  DOLPHIN_VESTING: "0xd022A7A6796Cdf97D04F0657dBb252cCB81B4354" // DolphinVesting contract (updated)
};

// RPC URL
export const RPC_MAINNET = "https://polygon-mainnet.g.alchemy.com/v2/0geOtcSw7wtMx4PX50pEe";
export const RPC_FALLBACK = RPC_MAINNET;

// Network Config for wallet
export const NETWORK_CONFIG = {
  chainId: "0x89",
  chainName: "Polygon Mainnet",
  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
  rpcUrls: [RPC_MAINNET],
  blockExplorerUrls: ["https://polygonscan.com/"]
};

export const ACTIVE_NETWORK = NETWORK_CONFIG;
